var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-divider',{attrs:{"content-position":"left"}},[_vm._v("特殊类目")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }